import moment from 'moment'
export function menuListToRoutes(children,list) {
    list.forEach(item=>{
        if(item.type<=1&&item.component){
            var obj = {
                // path: item.path,
                // name: item.name,
                // component: () => import('@/' + item.url + '.vue'),
                // label: item.label,
                path: item.address,
                name: item.code,
                component: () => import('@/' + item.component + '.vue'),
                meta: {
                    title: item.name,
                    icon: item.icon,
                    componentstr: item.component,
                    //keepAlive:true
                }
            }

            if(item.type!=1 && item.child!=undefined && item.child.length>0){
                let child = []
                obj['children'] = menuListToRoutes(child,item.child)
                if(obj['children'][0]){
                    obj['redirect'] = obj['children'][0].path
                }
            }
            // console.log('生成路由对象mm',obj)
            children.push(obj)
        }
    })
    return children
}
export function menuListToPermissions(children,list) {
    list.forEach(item=>{
        if(item.type<=1&&item.child!=undefined && item.child.length>0){
            menuListToPermissions(children,item.child)
        }else if(item.type===2){
            children.push(item.code)
        }
    })
    return children
}
/**
 * 根据id从树形结构查找父级所有id
 * @param data2 树形数据
 * @param id 查找id
 * @returns {[]}
 */
export function getParentIds(data2, id) {
    let arrRes = []
    // 如果非数组直接返回
    if (data2.length === 0) {
        if (id) {
            arrRes.unshift(data2)
        }
        return arrRes
    }
    const rev = (data, nodeId) => {
        for (let i = 0; i < data.length; i++) {
            const node = data[i]
            // 顶层直接跳出
            if (!nodeId && nodeId !== 0) break

            // 有则跳出循环再次递归
            if (node.id === nodeId) {
                arrRes.unshift(node.id)
                rev(data2, node.parent)
                break
            }
            else if (node.child) {
                rev(node.child, nodeId)
            }
        }
        // console.log('祖先节点',arrRes)
        return arrRes
    }
    arrRes = rev(data2, id)
    return arrRes
}

/**
 * 根据id从树形结构查找对应id节点对象
 * @param setValues 树形数据
 * @param valueId 查找id
 * @returns {*[]|[]|any|null}
 */
/*export function getParentNode(setValues, valueId) {
    let value = null
    for (let index = 0; index < setValues.length; index += 1) {
        if (setValues[index].id === valueId) {
            value = setValues[index].name
            break
        }
        if (setValues[index].child instanceof Array && setValues[index].child.length > 0) {
            const text = getParentNode(setValues[index].child, valueId)
            if (text)
                return text
        }
    }
    return value
}*/
/*export function getParentNode(data,id) {
    var hasFound = false, // 表示是否有找到id值
        result = null
    var fn = function (data) {
        if (Array.isArray(data) && !hasFound) { // 判断是否是数组并且没有的情况下，
            data.forEach(item => {
                if (item.id === id) { // 数据循环每个子项，并且判断子项下边是否有id值
                    result = item // 返回的结果等于每一项
                    hasFound = true // 并且找到id值
                } else if (item.child) {
                    fn(item.child) // 递归调用下边的子项
                }
            })
        }
    }
    fn(data) // 调用一下
    // console.log('父节点',result,id)
    return result
}*/
// 将富文本内容转为base64编码
export function Base64Encode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1)
    }))
}
// 将base64编码 转换成原来的文本
export function Base64Decode(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
}
export function CRC16(data) {
    var len = data.length
    if (len > 0) {
        var crc = 0xFFFF;

        for (var i = 0; i < len; i++) {
            crc = (crc ^ (data[i]))
            for (var j = 0; j < 8; j++) {
                crc = (crc & 1) != 0 ? ((crc >> 1) ^ 0xA001) : (crc >> 1)
            }
        }
        var hi = ((crc & 0xFF00) >> 8)  //高位置
        var lo = (crc & 0x00FF)         //低位置

        return [hi, lo]
    }
    return [0, 0]
}

export function ToModbusCRC16(str, isReverse) {
    return toString(CRC16(isArray(str) ? str : strToHex(str)), isReverse)
}
function toString(arr, isReverse) {
    if (typeof isReverse == 'undefined') {
        isReverse = true
    }
    var hi = arr[0], lo = arr[1]
    return padLeft((isReverse ? hi + lo * 0x100 : hi * 0x100 + lo).toString(16).toUpperCase(), 4, '0')
}
function padLeft(s, w, pc) {
    if (pc == undefined) {
        pc = '0'
    }
    for (var i = 0, c = w - s.length; i < c; i++) {
        s = pc + s
    }
    return s
}
function isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]'
}
function strToHex(hex, isFilterChinese) {
    hex = isFilterChinese ? filterChinese(hex).join('') : convertChinese(hex).join('')

    //清除所有空格
    hex = hex.replace(/\s/g, "")
    //若字符个数为奇数，补一个0
    hex += hex.length % 2 != 0 ? "0" : ""

    var c = hex.length / 2, arr = []
    for (var i = 0; i < c; i++) {
        arr.push(parseInt(hex.substr(i * 2, 2), 16))
    }
    return arr;
}
function filterChinese(str) {
    var tmp = str.split(''), arr = []
    for (var i = 0, c = tmp.length; i < c; i++) {
        var s = tmp[i].charCodeAt();
        if (s > 0 && s < 127) {
            arr.push(tmp[i])
        }
    }
    return arr
}
function convertChinese(str) {
    var tmp = str.split(''), arr = []
    for (var i = 0, c = tmp.length; i < c; i++) {
        var s = tmp[i].charCodeAt()
        if (s <= 0 || s >= 127) {
            arr.push(s.toString(16))
        }
        else {
            arr.push(tmp[i])
        }
    }
    return arr
}

/**
 * 年月日
 * @param date
 * @returns {*}
 */
export function timeFormat(date) {
    let aa = moment(date).format('YYYY-MM-DD')
    return aa
}

/**
 * 年月日时分秒
 * @param date
 * @returns {*}
 */
export function timeFormat1(date) {
    let aa = moment(date).format('YYYY-MM-DD HH:mm:ss')
    return aa
}
export function timeAdd(date,c,type) {
    return moment(date).add(c, type).format('YYYY-MM-DD')
}

export function getQueryVariable(variable){
    var url = window.location.href ;             //获取当前url
    var dz_url = url.split('#')[1];                //获取#/之前的字符串
    var cs = ''
    if(dz_url.indexOf('?')>-1){
        cs = dz_url.split('?')[1];  //获取?之后的参数字符串
    }else{
        cs=dz_url
    }
    var cs_arr = cs.split('&');                    //参数字符串分割为数组
    for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
        var pair = cs_arr[i].split("=");
        //console.log(pair[0],variable)
        if(pair[0] === variable){return pair[1];}
    }
    return null
}
export function GetQueryString1(){  //获取get的参数
    console.log('GetQueryString1',window.location)
    var r = window.location.href.toString().split('#/')
    if(r!=null)return  decodeURI(r[1]); return null;
}
export function GetPath(){
    //http://localhost/project.html#/setting?pid=332850301075525
    //http://localhost/project.html#/
    console.log('GetPath',window.location.href)
    var r = window.location.href.toString().split('#/')
    var r1=r[1].split("?")
    if(r1.length>1){
        return '/'+r1[0]
    }else{
        return ''
    }
}
